import React from "react"
import { TextBase, TextProps } from "./text"

export const BodyHeader1Medium = ({
  children,
  className,
  ...props
}: TextProps) => {
  return (
    <TextBase
      className={`text-size18 font-medium ${className ? className : ""}`}
      {...props}
    >
      {children}
    </TextBase>
  )
}

export const BodyHeader1Regular = ({
  children,
  className,
  ...props
}: TextProps) => {
  return (
    <TextBase
      className={`text-size18 font-normal ${className ? className : ""} tracking-[-0.5px]`}
      {...props}
    >
      {children}
    </TextBase>
  )
}

export const BodyHeader1Semibold = ({
  children,
  className,
  ...props
}: TextProps) => {
  return (
    <TextBase
      className={`text-size18 font-semibold ${className ? className : ""} tracking-[-0.5px]`}
      {...props}
    >
      {children}
    </TextBase>
  )
}

export const BodyHeader2Regular = ({
  children,
  className,
  ...props
}: TextProps) => {
  return (
    <TextBase
      className={`text-size16 font-normal ${className ? className : ""} tracking-[-0.5px]`}
      {...props}
    >
      {children}
    </TextBase>
  )
}

export const BodyHeader2Semibold = ({
  children,
  className,
  ...props
}: TextProps) => {
  return (
    <TextBase
      className={`text-size16 font-semibold ${className ? className : ""} tracking-[-0.5px]`}
      {...props}
    >
      {children}
    </TextBase>
  )
}
